import { render, staticRenderFns } from "./IhbarnameTalepEvrakEntryForm.vue?vue&type=template&id=e6721c8e&scoped=true"
import script from "./IhbarnameTalepEvrakEntryForm.vue?vue&type=script&lang=ts"
export * from "./IhbarnameTalepEvrakEntryForm.vue?vue&type=script&lang=ts"
import style0 from "./IhbarnameTalepEvrakEntryForm.vue?vue&type=style&index=0&id=e6721c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6721c8e",
  null
  
)

export default component.exports